import  {eXcell,__extends} from './eXcell';

var eXcell_cntr = (function (_super) {
    __extends(eXcell_cntr, _super);
    function eXcell_cntr(a) {
        _super.call(this);
        this.cell = a;
        this.grid = this.cell.parentNode.grid;
        if (!this.grid._ex_cntr_ready && !this._realfake) {
            this.grid._ex_cntr_ready = true;
            if (this.grid._h2) {
                this.grid.attachEvent("onOpenEn", function (e) {
                   
                    this.resetCounter(a._cellIndex);
                });
            }
            var c = function c() {
               
                var e = this;
                window.setTimeout(function () {
                    if (!e.resetCounter) {
                        return;
                    }
                    if (e._fake && !e._realfake && a._cellIndex < e._fake._cCount) {
                        e._fake.resetCounter(a._cellIndex);
                    }
                    else {
                        e.resetCounter(a._cellIndex);
                    }
                }, 1);
                return true;
            };
            this.grid.attachEvent("onBeforeSorting", c);
            this.grid.attachEvent("onFilterEnd", c);
        }
    }
    eXcell_cntr.prototype.edit = function () { };
    eXcell_cntr.prototype.getValue = function () {
        return this.cell.innerHTML;
    };
    eXcell_cntr.prototype.setValue = function (g) {
        this.cell.style.paddingRight = "2px";
        var e = this.cell;
        window.setTimeout(function () {
            if (!e.parentNode) {
                return;
            }
            var h = e.parentNode.rowIndex;
            if (e.parentNode.grid.currentPage || h < 0 || e.parentNode.grid._srnd) {
                h = e.parentNode.grid.rowsBuffer._dhx_find(e.parentNode) + 1;
            }
            if (h <= 0) {
                return;
            }
            e.innerHTML = '<div class="grid-index-cell">' + h + "</div>";
            e.className = "grid-index-td";
            if (e.parentNode.grid._fake &&
                e._cellIndex < e.parentNode.grid._fake._cCount &&
                e.parentNode.grid._fake.rowsAr[e.parentNode.idd]) {
                e.parentNode.grid._fake
                    .cells(e.parentNode.idd, e._cellIndex)
                    .setCValue(h);
            }
            e = null;
        }, 100);
    };
    return eXcell_cntr;
})(eXcell);
window.eXcell_cntr = eXcell_cntr;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_cntr.js